import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { VerticalDotsIcon } from 'v2/icons';
import { useResendUserInvite, useDeleteUserInvite } from 'v2/queries';
import styles from './InvitedUserActions.module.scss';

type InvitedUserActionsProps = {
  userInviteID: number;
};

export function InvitedUserActions({ userInviteID }: InvitedUserActionsProps) {
  const { mutate: resendUserInvite } = useResendUserInvite();
  const { mutate: deleteUserInvite } = useDeleteUserInvite();

  const handleSendReminder = () => {
    resendUserInvite(userInviteID);
  };

  const handleRemoveInvitation = () => {
    deleteUserInvite(userInviteID);
  };

  return (
    <Dropdown className={styles.dropdown}>
      <Dropdown.Toggle
        variant="link"
        className="p-0"
        aria-label="Invited user actions"
      >
        <VerticalDotsIcon
          style={{
            width: 20,
            height: 20,
          }}
        />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={handleSendReminder}>
          Send Reminder
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Item onClick={handleRemoveInvitation}>
          Remove Invitation
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
